<template lang="pug">
v-skeleton-loader(
  type="card-avatar, article, actions"
)
</template>

<style lang="scss">
@import '~@/plugins/vuetify/default-preset/preset/misc.scss';
</style>

<script>
export default {
  props: {
    site: String,
    eref: String,
    form: Object,
    data: Object,
    entity: Object,
  },

  computed: {
  },
}
</script>
